<template>
    <div class="input-group">
        <input type="text" class="form-control" aria-label="Text input with dropdown button" :value="tag" disabled>
        <button class="btn btn-outline-danger" type="button" @click="removeTag(tag, currentFamily)">
            <span class="bi bi-trash text-danger"></span>
        </button>
        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                aria-expanded="false">Move To
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
            <li v-for="family in families">
                <a class="dropdown-item" href="#" @click="changeFamily(tag, currentFamily, family)">{{ family }}</a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        tag: {
            type: String,
            required: true,
        },
        currentFamily: {
            type: String,
            required: true,
        },
        families: {
            type: Object,
            required: true
        }
    },

    methods: {
        changeFamily(tag, oldFamily, newFamily) {
            this.$emit("change-family", tag, oldFamily, newFamily);
        },

        removeTag(tag, family) {
            this.$emit("remove-tag", tag, family);
        }
    },
    emits: [ 'change-family', 'remove-tag' ]
}
</script>
